import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { captureInboundReferral } from '../components/useReferral';
// ROUTE: /r/:code — the destination of a shared waitlist invite link.
// It records the inbound referral code, then forwards the visitor into the
// waitlist flow with the code attached so the modal can credit the referrer
// and show an "<code> invited you" banner.
export function ReferralCapture() {
  const {
    code
  } = useParams<{
    code: string;
  }>();
  const navigate = useNavigate();
  useEffect(() => {
    const clean = (code ?? '').trim().toLowerCase();
    if (clean) {
      captureInboundReferral(clean);
      navigate(`/signup?waitlist=1&ref=${encodeURIComponent(clean)}`, {
        replace: true
      });
    } else {
      navigate('/signup?waitlist=1', {
        replace: true
      });
    }
  }, [code, navigate]);
  // Brief, on-brand interstitial while we redirect into the waitlist.
  return <div className="min-h-screen w-full flex items-center justify-center bg-[#FBF9F5] text-[#2B211A]" data-id="element-6224">
      <div className="flex flex-col items-center gap-4" data-id="element-6225">
        <span className="flex items-center justify-center w-12 h-12 rounded-2xl bg-gradient-to-b from-[#F97316] to-[#EA580C] shadow-[0_8px_24px_rgba(234,88,12,0.4)]" data-id="element-6226">
          <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/c9cswf4udjck7zyoebqqwd/8f9cf306-0595-4050-830d-816cae832d54/Vector.png" alt="Giga" className="w-6 h-6 object-contain [filter:brightness(0)_invert(1)]" data-id="element-6227" />
        </span>
        <p className="text-sm font-medium text-[#6B5D52]" data-id="element-6228">
          Opening your invite…
        </p>
      </div>
    </div>;
}